// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2NEtB","label":"Section_label__16aXS","contentWrap":"Section_contentWrap__2zPGH","footer":"Section_footer__2jJ7O","footerInner":"Section_footerInner__21DtG"};